<template>
  <section class="hero">
    <div class="container">
      <div class="hero__row">
        <div class="hero__content">
          <div class="hero__headings">
            <h1 class="hero__title h1">
              Национальная технологическая олимпиада
            </h1>
            <p class="hero__subtitle">
              Первые в&nbsp;стране уникальные командные инженерные соревнования
              для школьников и&nbsp;студентов, увлечённых наукой
              и&nbsp;технологиями. Здесь участники решают реальные задачи
              от&nbsp;компаний и&nbsp;вузов, находят друзей
              и&nbsp;единомышленников, открывают путь в&nbsp;лучшие университеты
              и&nbsp;становятся востребованными специалистами.
            </p>
          </div>

          <div v-if="!loading">
            <div v-if="startDuration > 0">
              <div class="mb-s">Начнется через:</div>
              <StartCount :duration="startDuration" />

              <div v-if="preRegUrl">
                <div class="mt-l mb-l">
                  А&nbsp;пока приглашаем пройти предварительную регистрацию
                  на&nbsp;платформе &laquo;Талант&raquo;,
                  и&nbsp;мы&nbsp;уведомим вас о&nbsp;старте олимпиады!
                </div>
                <BaseButton
                  tag="a"
                  size="lg"
                  theme="primary"
                  :href="preRegUrl"
                  class="hero__btn hero__btn-reg"
                  >Предварительная регистрация</BaseButton
                >
              </div>
            </div>

            <div v-else-if="isAllRegClosed">
              <BaseButton
                v-if="loginUrl"
                tag="a"
                size="lg"
                theme="reg"
                :href="loginUrl"
                class="hero__btn"
                @click="
                  gtmEvent({
                    eventLabel: 'slider_block',
                    eventAction: 'go_to_enter_account',
                  })
                "
                >войти в учетную запись</BaseButton
              >
              <div class="mt-l mb-s">
                Регистрация на текущий сезон олимпиады завершена.
              </div>
              <div v-if="preRegUrl">
                <div class="mb-l">
                  А&nbsp;пока приглашаем пройти предварительную регистрацию
                  на&nbsp;платформе &laquo;Талант&raquo;,
                  и&nbsp;мы&nbsp;уведомим вас о&nbsp;старте олимпиады!
                </div>
                <BaseButton
                  tag="a"
                  size="lg"
                  theme="primary"
                  :href="preRegUrl"
                  class="hero__btn hero__btn-reg"
                  >Предварительная регистрация</BaseButton
                >

                <!-- <BaseButton
                v-if="preRegUrl"
                tag="a"
                size="lg"
                theme="primary"
                :href="preRegUrl"
                class="hero__btn hero__btn-reg"
                >Предварительная регистрация</BaseButton
              > -->
              </div>
            </div>

            <div
              v-else
              class="hero__footer">
              <BaseButton
                v-if="regUrl"
                tag="a"
                size="lg"
                theme="primary"
                :href="regUrl"
                class="hero__btn hero__btn-reg"
                @click="
                  gtmEvent({
                    eventLabel: 'slider_block',
                    eventAction: 'go_to_registration',
                  })
                "
                >Зарегистрироваться</BaseButton
              >

              <BaseButton
                v-if="loginUrl"
                tag="a"
                size="lg"
                theme="reg"
                :href="loginUrl"
                class="hero__btn"
                @click="
                  gtmEvent({
                    eventLabel: 'slider_block',
                    eventAction: 'go_to_enter_account',
                  })
                "
                >войти в учетную запись</BaseButton
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StartCount from "./StartCount.vue";
export default {
  name: "Hero",
  components: { StartCount },
  props: {
    regUrl: {
      type: String,
      default: "",
    },
    loginUrl: {
      type: String,
      default: "",
    },
    preRegUrl: {
      type: String,
      default: "",
    },
    isAllRegClosed: {
      type: Boolean,
    },
    startDuration: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    gtmEvent(params) {
      window.dataLayer?.push({
        event: "ntoLandingEvent",
        eventCategory: "nto_landing_cta",
        ...params,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@header-height: 172px;
@header-height--mobile: 65px;

.hero {
  display: flex;
  align-items: center;
  min-height: calc(100vh - @header-height);
  overflow: hidden;
  position: relative;

  &__row {
    display: flex;
    justify-content: space-between;
  }

  &__content {
    position: relative;
    max-width: 660px;
    z-index: 1;
  }

  &__headings {
    position: relative;
    margin-bottom: 64px;
  }

  &__title {
    color: @azure-blue;
    margin-bottom: 48px !important;
    text-shadow: 4px 3px 0px #00031d;
    letter-spacing: -1.6px;
  }

  &__subtitle {
    color: @white-blue;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: 146%;
  }

  &__footer {
    display: flex;
    align-items: center;
  }

  &__btn {
    margin-right: 30px;
    flex-shrink: 0;
  }

  &__start {
    position: relative;
    color: #a6c4fe;
    margin-bottom: 0;
    padding-left: 80px;

    &::before {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      bottom: 0;
      width: 48px;
      height: 31px;
      margin: auto;
      background-image: url("/assets/images/landing/hero/hero_arrow.svg");
      background-repeat: no-repeat;
    }
  }

  .link {
    color: @principal-blue-light;
  }

  @media (max-width: @screen-lg) {
    background-position: right 10% top 50%;

    &__content {
      max-width: 540px;
      margin-right: 50px;
    }

    &__subtitle {
      font-size: 18px;
    }

    &__stage {
      opacity: 0.4;
    }
  }

  @media (max-width: @screen-md) {
    min-height: calc(100vh - @header-height--mobile);

    &__row {
      display: block;
    }

    &__content {
      margin-top: 50px;
      margin-right: 0;
      max-width: 100%;
    }

    &__headings {
      margin-bottom: 48px;
    }

    &__title {
      margin-bottom: 20px !important;
    }

    &__footer {
      max-width: 100%;
      display: block;
    }

    &__btn {
      width: 100%;
      max-width: 100%;
      margin-bottom: 23px;
      margin-right: 0;
    }
  }

  @media (max-width: @screen-xs) {
    &__content {
      z-index: initial;
    }
    &__start {
      padding-left: 55px;

      &::before {
        width: 33px;
        height: 31px;
        background-position: right center;
      }
    }

    &__btn-reg {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      margin-bottom: 0;
      z-index: 10;
    }
  }
}
</style>
